import { render, staticRenderFns } from "./GfInformationDigest.vue?vue&type=template&id=3b37cd96&scoped=true&lang=html&"
import script from "./GfInformationDigest.vue?vue&type=script&lang=js&"
export * from "./GfInformationDigest.vue?vue&type=script&lang=js&"
import style0 from "./GfInformationDigest.vue?vue&type=style&index=0&id=3b37cd96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37cd96",
  null
  
)

export default component.exports